import React from "react";
import { SpecialZoomLevel, Viewer, Worker } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import { zoomPlugin } from "@react-pdf-viewer/zoom";
import { toolbarPlugin } from "@react-pdf-viewer/toolbar";
import { fullScreenPlugin } from "@react-pdf-viewer/full-screen";
import "@react-pdf-viewer/full-screen/lib/styles/index.css";
import { getFilePlugin } from "@react-pdf-viewer/get-file";
import pdfjsWorker from "pdfjs-dist/build/pdf.worker.entry";
import "./incidentes.css";

const PdfViewerCard = ({ pdfUrl, titulo }) => {
  const zoomPluginInstance = zoomPlugin();
  const toolbarPluginInstance = toolbarPlugin();
  const fullScreenPluginInstance = fullScreenPlugin();
  const getFilePluginInstance = getFilePlugin();

  const { ZoomInButton, ZoomOutButton, ZoomPopover } = zoomPluginInstance;
  const { Toolbar } = toolbarPluginInstance;
  const { EnterFullScreenButton } = fullScreenPluginInstance;
  const { DownloadButton } = getFilePluginInstance;

  return (
    <div className="pdfpro-wrap">
      <div className="pdfpro-card">
        {titulo && <div className="pdfpro-title">{titulo}</div>}

        <div className="pdfpro-toolbar">
          <Toolbar>
            {(slots) => {
              const {
                CurrentPageInput,
                GoToNextPage,
                GoToPreviousPage,
                NumberOfPages,
              } = slots;
              return (
                <>
                  <div className="pdfpro-toolbar-group">
                    <ZoomOutButton />
                    <ZoomPopover />
                    <ZoomInButton />
                  </div>

                  <div className="pdfpro-toolbar-group pdfpro-toolbar-pages">
                    <GoToPreviousPage />
                    <CurrentPageInput />
                    <span className="pdfpro-toolbar-of">/</span>
                    <NumberOfPages />
                    <GoToNextPage />
                  </div>

                  <div className="pdfpro-toolbar-group">
                    <DownloadButton />
                    <EnterFullScreenButton />
                  </div>
                </>
              );
            }}
          </Toolbar>
        </div>

        <div className="pdfpro-body">
          <Worker workerUrl={pdfjsWorker}>
            <Viewer
              fileUrl={pdfUrl}
              defaultScale={SpecialZoomLevel.PageWidth}
              plugins={[
                zoomPluginInstance,
                toolbarPluginInstance,
                fullScreenPluginInstance,
                getFilePluginInstance,
              ]}
            />
          </Worker>
        </div>
      </div>
    </div>
  );
};

export default PdfViewerCard;
